<template>
  <div class="mt-4 mb-4 w-full text-center">
    <div v-if="props.loading" data-testid="leads-loading">LOADING</div>
    <div v-else data-testid="leads-empty-state">{{ t('EventsLeadsCount.noLeadsFound') }}</div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps<{
  loading: boolean
}>()
</script>
